
export const RETAILER_IS_SET = "tryabuy/account/RETAILER_IS_SET";

export function setRetailer(retailer) {
  return {
    type: RETAILER_IS_SET,
    data: retailer
  }
}
